import { Button, Modal } from "antd";

const ConfirmationModal = ({
  open,
  title,
  message,
  confirmText = "Yes",
  cancelText = "Cancel",
  confirmLoading = false,
  onConfirm,
  width = 520,
  onCancel,
}) => (
  <Modal
    centered
    open={open}
    maskClosable={false}
    title={title}
    width={width}
    footer={[
      <Button key="cancel" className="btn_gray" onClick={onCancel}>
        {cancelText}
      </Button>,
      <Button
        key="confirm"
        className="btn_gray"
        loading={confirmLoading}
        onClick={onConfirm}
      >
        {confirmText}
      </Button>,
    ]}
    onCancel={onCancel}
  >
    <p>{message}</p>
  </Modal>
);

export default ConfirmationModal;
